const MODULE_NAME = 'regulation'
const SET_REGULATION = 'setRegulation'

export const mutationTypes = {
  SET_REGULATION
}

export const globalMutationTypes = {
  SET_REGULATION: `${MODULE_NAME}/${SET_REGULATION}`
}

export const mutations = {
  [SET_REGULATION] (state, payload) {
    state.regulation = payload
  }
}



// WEBPACK FOOTER //
// ./src/store/module/regulation/mutations.js